import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import SmsMetricsPieChart from 'components/molecules/sms-metrics/pie-chart';
import { useGetPatientEngagementBreakdown } from 'infrastructure/hooks/patient-engagement-report';

import type { TPatientEngagementReportFilter } from 'infrastructure/hooks/patient-engagement-report';

interface IProps {
  filter: TPatientEngagementReportFilter;
}

const StatusOverviewPieChart: React.FC<IProps> = ({ filter }) => {
  const { t } = useTranslation();
  const { statusBreakdown, isLoading } =
    useGetPatientEngagementBreakdown(filter);

  return (
    <BaseSpinWrapper spinning={isLoading}>
      <SmsMetricsPieChart
        title={t('patientEngagementReport.statusOverview')}
        data={statusBreakdown}
        compact
      />
    </BaseSpinWrapper>
  );
};

export default StatusOverviewPieChart;
